import { render, staticRenderFns } from "./AppMenu.vue?vue&type=template&id=4ed95c35&scoped=true&"
import script from "./AppMenu.vue?vue&type=script&lang=js&"
export * from "./AppMenu.vue?vue&type=script&lang=js&"
import style0 from "./AppMenu.vue?vue&type=style&index=0&id=4ed95c35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed95c35",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ed95c35')) {
      api.createRecord('4ed95c35', component.options)
    } else {
      api.reload('4ed95c35', component.options)
    }
    module.hot.accept("./AppMenu.vue?vue&type=template&id=4ed95c35&scoped=true&", function () {
      api.rerender('4ed95c35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SuperAdmin/AppMenu.vue"
export default component.exports